export default "__VITE_ASSET__ax3xmbHq__"